import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/user/exit',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/user/info',
    method: 'post',
    data
  })
}

export function userRegister(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/user/sms/send/code',
    method: 'post',
    data
  })
}

export function findSmsCode(data) {
  return request({
    url: '/user/sms/find/code',
    method: 'post',
    data
  })
}

export function userFindPassword(data) {
  return request({
    url: '/user/password/find/save',
    method: 'post',
    data
  })
}

export function getCourseItemInfo(data) {
  return request({
    url: '/user/course/item/info',
    method: 'post',
    data
  })
}

export function getClassTimeFeedback(data) {
  return request({
    url: '/student/class/time/feedback',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/student/index.js